module.exports = __webpack_public_path__ + "img/bonfino_logo.cbd99a52.png";